module.exports = __webpack_public_path__ + "img/sharing.0c0210cc.svg";